import { motion } from "framer-motion";

const LABELS = ["New Possibilities", "Relating to Others", "Personal Strength", "Appreciation for Life", "Spiritual / Existential"];
const BEFORE = [0.3, 0.26, 0.34, 0.3, 0.22];
const AFTER = [0.82, 0.76, 0.9, 0.86, 0.72];
const C = 200, R = 130;

const pt = (i, r) => {
  const a = -Math.PI / 2 + (i * 2 * Math.PI) / 5;
  return [C + Math.cos(a) * R * r, C + Math.sin(a) * R * r];
};
const poly = (vals) => vals.map((v, i) => pt(i, v).join(",")).join(" ");
const path = (vals) => `M${vals.map((v, i) => pt(i, v).join(",")).join("L")}Z`;
const ease = [0.2, 0.8, 0.2, 1];
const view = { once: true, amount: 0.3 };

export const DomainChart = () => (
  <figure className="w-full max-w-[460px] mx-auto" data-testid="domain-chart">
    <div className="relative">
    <svg viewBox="0 0 400 400" className="w-full h-auto overflow-visible" role="img" aria-label="Illustrative chart of growth across the five PTGI domains">
      {[0.25, 0.5, 0.75, 1].map((r) => (
        <polygon key={r} points={poly([r, r, r, r, r])} fill="none" stroke="var(--kh-border)" strokeWidth="1" />
      ))}
      {LABELS.map((_, i) => {
        const [x, y] = pt(i, 1);
        return <line key={i} x1={C} y1={C} x2={x} y2={y} stroke="var(--kh-border)" strokeWidth="1" />;
      })}
      <motion.path d={path(BEFORE)} fill="rgba(107,96,85,0.08)" stroke="var(--kh-text-muted)" strokeWidth="1" strokeDasharray="3 4"
        initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={view} transition={{ duration: 0.8 }} />
      <motion.path d={path(AFTER)} fill="rgba(158,74,43,0.12)" stroke="var(--kh-accent)" strokeWidth="1.5"
        initial={{ pathLength: 0, fillOpacity: 0 }} whileInView={{ pathLength: 1, fillOpacity: 1 }} viewport={view}
        transition={{ pathLength: { duration: 1.8, delay: 0.5, ease }, fillOpacity: { duration: 0.8, delay: 2 } }} />
      {AFTER.map((v, i) => {
        const [x, y] = pt(i, v);
        return (
          <motion.circle key={i} cx={x} cy={y} r="4" fill="var(--kh-accent)"
            initial={{ scale: 0 }} whileInView={{ scale: 1 }} viewport={view} transition={{ duration: 0.4, delay: 0.7 + i * 0.3 }} />
        );
      })}
    </svg>
    {LABELS.map((l, i) => {
      const [x, y] = pt(i, 1.12);
      const tx = Math.abs(x - C) < 5 ? "-50%" : x > C ? "0%" : "-100%";
      const ty = y < C - 50 ? "-100%" : y > C + 50 ? "0%" : "-50%";
      return (
        <span key={l} className="absolute text-[11px] sm:text-xs leading-tight w-max max-w-[90px] sm:max-w-[150px]"
          style={{ left: `${(x / 400) * 100}%`, top: `${(y / 400) * 100}%`, transform: `translate(${tx}, ${ty})`, textAlign: tx === "-100%" ? "right" : tx === "0%" ? "left" : "center", color: "var(--kh-text)" }}
          data-testid={`domain-chart-label-${i + 1}`}>
          <span className="kh-mono block" style={{ color: "var(--kh-accent)", fontSize: "10px" }}>{String(i + 1).padStart(2, "0")}</span>{l}
        </span>
      );
    })}
    </div>
    <figcaption className="mt-4 flex flex-wrap justify-center gap-x-6 gap-y-2 text-xs" style={{ color: "var(--kh-text-muted)" }}>
      <span className="flex items-center gap-2"><span className="w-5 border-t border-dashed" style={{ borderColor: "var(--kh-text-muted)" }} />Before</span>
      <span className="flex items-center gap-2"><span className="w-5 border-t-2" style={{ borderColor: "var(--kh-accent)" }} />After</span>
      <span>Illustrative only, not clinical data</span>
    </figcaption>
  </figure>
);
